export const ROLES = {
  owner: { label: "Owner", description: "Full access. One per organization." },
  admin: { label: "Admin", description: "Full access, alongside the owner." },
  agent: { label: "Agent", description: "Runs lets day to day." },
  viewer: { label: "Viewer", description: "Can look, can't change anything." },
};

export const ROLE_ORDER = ["owner", "admin", "agent", "viewer"];

const ALLOWED = {
  view: ["owner", "admin", "agent", "viewer"],
  decide: ["owner", "admin", "agent"],
  edit: ["owner", "admin", "agent"],
  keys: ["owner", "admin"],
  members: ["owner", "admin"],
  business: ["owner", "admin"],
};

export const PERMISSIONS = [
  { label: "View applicants and properties", perm: "view" },
  { label: "Accept or decline applicants", perm: "decide" },
  { label: "Add and edit properties", perm: "edit" },
  { label: "Create and reveal API keys", perm: "keys" },
  { label: "Invite and remove members", perm: "members" },
  { label: "Edit business name and logo", perm: "business" },
];

export const can = (role, perm) => !!role && ALLOWED[perm].includes(role);
